import { AddOnsProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getAddonsProducts(divisionId: number) {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.addons_get_all.replace("{divisionId}", divisionId.toString()),
    mapAddOnProducts,
    "Failed to fetch addon products");
}

function mapAddOnProducts(AddonProduct: any): AddOnsProduct {
    return {
        id: AddonProduct.productId,
        name: AddonProduct.productName,
        lastModifiedDate: AddonProduct.lastModifiedDate,
        lastUpdatedBy: AddonProduct.lastModifiedBy,
        divisionText: AddonProduct.division,
        division:AddonProduct.divisionId,
        typeId : AddonProduct.typeId,
        typeText : AddonProduct.typeText,
        unitTypeText: AddonProduct.unitTypeText,
        unitTypeId:AddonProduct.unitTypeId,
        entityUpdate: AddonProduct.entityUpdate,
        accountCategories: AddonProduct.accountCategories,
        productCategories: AddonProduct.productCategories,
        commissionCategories: AddonProduct.commissionCategories,
        productCategoryId: AddonProduct.productCategoryId,
        accountCategoryText: AddonProduct.accountCategoryText,
        productCategoryText: AddonProduct.productCategoryText,
        active: AddonProduct.active,
        minimumAge: AddonProduct.minimumAge ?? null,
        excludedBookingSystemIds: [],
        hasActiveOffering: readHasActiveOffering(AddonProduct),
        isUsedInActivePackage: readIsUsedInActivePackage(AddonProduct),
    }
}